import { useQuery } from '@tanstack/react-query';
import { fetchPositions, fetchStaticData, fetchBaseData, fetchConfig, fetchUnlocodeRegister, fetchCountries } from '../api/vessels';
import type { BaseVesselData } from '../types/vessel';

export function useConfig() {
  return useQuery({
    queryKey: ['config'],
    queryFn: fetchConfig,
    staleTime: Infinity,
  });
}

export function usePositions() {
  return useQuery({
    queryKey: ['positions'],
    queryFn: fetchPositions,
    refetchInterval: 5 * 60 * 1000,
  });
}

export function useStaticData() {
  return useQuery({
    queryKey: ['staticData'],
    queryFn: fetchStaticData,
    staleTime: Infinity,
  });
}

export function useBaseData() {
  return useQuery({
    queryKey: ['baseData'],
    queryFn: async () => {
      const data = await fetchBaseData();
      const map: Record<string, BaseVesselData> = {};
      data.forEach((item) => {
        if (item?.IHSLRorIMOShipNo) {
          map[item.IHSLRorIMOShipNo.toString().trim()] = item;
        }
      });
      return map;
    },
    staleTime: Infinity,
  });
}

export function useUnlocodeRegister() {
  return useQuery({
    queryKey: ['unlocode'],
    queryFn: fetchUnlocodeRegister,
    staleTime: Infinity,
  });
}

export function useCountries() {
  return useQuery({
    queryKey: ['countries'],
    queryFn: fetchCountries,
    staleTime: Infinity,
  });
}
